import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueAnalytics from 'vue-analytics'
import VueMeta from 'vue-meta'
import VeeValidate from 'vee-validate'

Vue.config.productionTip = false

Vue.use(VeeValidate)
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
})

if (process.env.VUE_APP_ANALYTICS_ID) {
  Vue.use(VueAnalytics, {
    id: process.env.VUE_APP_ANALYTICS_ID,
    router
  })
}

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
